<!-- Main Content -->
<div class="container mt-4">
    <!-- Tiêu đề với biểu tượng -->
    <h1 class="h3 mb-2 text-gray-800">
      <i class="fas fa-file-contract mr-2"></i>Hợp Đồng
    </h1>

    <!-- Mô tả dưới tiêu đề -->
    <p class="lead mb-4">
      Quản lý và xem xét tất cả các hợp đồng trong hệ thống. Sử dụng các tab để điều hướng qua các phần khác nhau bao gồm tổng quan về dữ liệu hợp đồng, danh sách chi tiết các hợp đồng và hướng dẫn sử dụng để biết thêm thông tin. Nhấn "Thêm Hợp Đồng" để tạo mục mới.
    </p>

    <!-- Tab Điều Hướng -->
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link active" data-toggle="tab" href="#List">
          <i class="fas fa-list mr-2"></i> Danh Sách
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-toggle="tab" href="#UserManual">
          <i class="fas fa-book mr-2"></i> Hướng Dẫn Sử Dụng
        </a>
      </li>
    </ul>

    <!-- Nội Dung Tab -->
    <div class="tab-content">
      <!-- Nội dung tab Danh Sách -->
      <div id="List" class="tab-pane fade show active">
        <div class="container-fluid">
          <button class="btn btn-outline-primary mb-3" (click)="openAddDialog()">Thêm Hợp Đồng</button>
          <button
          href="#"
          role="button"
          class="btn btn-outline-warning btn-icon-split"
          (click)="loadContracts()"
        >
          <span class="icon text-warning">
            <i class="fas fa-redo"></i>
          </span>
          <span class="text">Tải Lại</span>
        </button>

          <div class="card mb-4">
            <div class="card-body">
              <div class="table-responsive">
                <div *ngIf="loadingIndicator; else loaded">
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Đang tải...</span>
                    </div>
                  </div>
                </div>

                <ng-template #loaded>
                  <ngx-datatable
  class="bootstrap"
  [rows]="contracts"
  [columnMode]="'force'"
  [headerHeight]="50"
  [footerHeight]="50"
  [rowHeight]="'auto'"
  [limit]="10"
  [loadingIndicator]="loadingIndicator"
  [reorderable]="reorderable"
  (select)="onSelect($event)"
  (activate)="onActivate($event)">

  <!-- Số Hợp Đồng -->
  <ngx-datatable-column name="Số Hợp Đồng" [prop]="'contractNumber'">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.contractNumber }}
    </ng-template>
  </ngx-datatable-column>

  <!-- Ngày Bắt Đầu -->
  <ngx-datatable-column name="Ngày Bắt Đầu" [prop]="'startDate'">
    <ng-template ngx-datatable-cell-template let-row="row">
      <span style="color: red;">{{ row.startDate | date }}</span>
    </ng-template>
  </ngx-datatable-column>

  <!-- Ngày Kết Thúc -->
  <ngx-datatable-column name="Ngày Kết Thúc" [prop]="'endDate'">
    <ng-template ngx-datatable-cell-template let-row="row">
      <span style="color: blue;">{{ row.endDate | date }}</span>
    </ng-template>
  </ngx-datatable-column>

  <!-- Nhà Cung Cấp -->
  <ngx-datatable-column name="Nhà Cung Cấp" [prop]="'vendor.name'">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.vendor?.name }}
    </ng-template>
  </ngx-datatable-column>

  <!-- Điều Khoản -->
  <ngx-datatable-column name="Điều Khoản" [prop]="'terms'">
    <ng-template ngx-datatable-cell-template let-row="row">
      {{ row.terms }}
    </ng-template>
  </ngx-datatable-column>

  <!-- Hành Động -->
  <ngx-datatable-column name="Hành Động">
    <ng-template ngx-datatable-cell-template let-row="row">
      <button type="button" class="btn btn-outline-primary dropdown-toggle btn-sm" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Hành Động
      </button>
      <div class="dropdown-menu">
        <a class="dropdown-item"  (click)="openEditDialog(row)">
          <i class="fas fa-edit"></i> Chỉnh Sửa
        </a>
        <a class="dropdown-item"  (click)="deleteContract(row.id)">
          <i class="fas fa-trash-alt"></i> Xóa
        </a>
        <a class="dropdown-item" (click)="openUploadDialog(row)">
          <i class="fas fa-upload"></i> Tải Tài Liệu Lên
        </a>
        <a class="dropdown-item" (click)="openViewDialog(row)">
          <i class="fas fa-eye"></i> Xem
        </a>
        <a class="dropdown-item" (click)="sendReminder(row)">
          <i class="fas fa-clock"></i> Gửi Nhắc Nhở
        </a>
      </div>
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>
</ng-template> 
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Nội dung tab Hướng Dẫn Sử Dụng -->
      <div id="UserManual" class="tab-pane fade" style="background-color: white;">
        <div>
           <div  [innerHTML]="markdownContent"></div>
       </div>
      </div>
    </div>
  </div>

  <!-- Modal cho Biểu Mẫu Thông Tin Hợp Đồng -->
  <div class="modal fade" id="orderFormModal" tabindex="-1" aria-labelledby="orderFormModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="orderFormModalLabel">Biểu Mẫu Thông Tin Hợp Đồng</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Đóng"></button>
        </div>
        <div class="modal-body">
          <form action="#" method="post">
            <div class="form-group">
              <label for="contractName">Tên Hợp Đồng:</label>
              <input type="text" class="form-control" id="contractName" name="contractName" required>
            </div>
            <div class="form-group">
              <label for="contractDescription">Mô Tả:</label>
              <textarea class="form-control" id="contractDescription" name="contractDescription" required></textarea>
            </div>
            <div class="form-group">
              <label for="startDate">Ngày Bắt Đầu:</label>
              <input type="date" class="form-control" id="startDate" name="startDate" required>
            </div>
            <div class="form-group">
              <label for="endDate">Ngày Kết Thúc:</label>
              <input type="date" class="form-control" id="endDate" name="endDate" required>
            </div>
            <button type="submit" class="btn btn-primary mt-3">Gửi</button>
          </form>
        </div>
      </div>
    </div>
  </div>

